import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

class TestingPTProviderService {
  static async getPTProvidersByType(type) {
    try {
      const response = await axios.get(`${API_BASE_URL}/testing-pt-provider/providers/${type}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching ${type} PT providers:`, error);
      throw error;
    }
  }

  static async getNABLPTProviders() {
    try {
      const response = await axios.get(`${API_BASE_URL}/testing-pt-provider/nabl-providers`);
      return response.data;
    } catch (error) {
      console.error('Error fetching NABL PT providers:', error);
      throw error;
    }
  }

  static async getOtherPTProviders() {
    try {
      const response = await axios.get(`${API_BASE_URL}/testing-pt-provider/other-providers`);
      return response.data;
    } catch (error) {
      console.error('Error fetching other PT providers:', error);
      throw error;
    }
  }

  static async getAllPTProviders() {
    try {
      const response = await axios.get(`${API_BASE_URL}/testing-pt-provider/all-providers`);
      return response.data;
    } catch (error) {
      console.error('Error fetching all PT providers:', error);
      throw error;
    }
  }

  // CRUD operations for ptProvider_new table
  static async getPTProviderData(appId, orgId = null) {
    try {
      const url = orgId 
        ? `${API_BASE_URL}/testing-pt-provider/data/${appId}/${orgId}`
        : `${API_BASE_URL}/testing-pt-provider/data/${appId}`;
      
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching PT provider data:', error);
      throw error;
    }
  }

  static async insertPTProviderData(data) {
    try {
      const response = await axios.post(`${API_BASE_URL}/testing-pt-provider/data`, data);
      return response.data;
    } catch (error) {
      console.error('Error inserting PT provider data:', error);
      throw error;
    }
  }

  static async updatePTProviderData(id, data) {
    try {
      const response = await axios.put(`${API_BASE_URL}/testing-pt-provider/data/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating PT provider data:', error);
      throw error;
    }
  }

  static async deletePTProviderData(id) {
    try {
      const response = await axios.delete(`${API_BASE_URL}/testing-pt-provider/data/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting PT provider data:', error);
      throw error;
    }
  }

  static async savePTProviderData(data) {
    try {
      const response = await axios.post(`${API_BASE_URL}/testing-pt-provider/save`, data);
      return response.data;
    } catch (error) {
      console.error('Error saving PT provider data:', error);
      throw error;
    }
  }
}

export default TestingPTProviderService;
